import React, { useEffect, useRef, useState } from 'react';
import { userService } from 'services/user.service';
import { Paginator } from 'primereact/paginator';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { routes } from 'utils/routes';
import { useNavigate, useSearchParams } from 'react-router-dom';
import DeleteItem from 'views/components/delete-modal';
import { SEOHeader } from 'views/components';
import './style.scss'
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { _Object, getStatusLabel, showTostify } from 'utils/interfaces';
import CustomToast from 'views/components/form-inputs/alert';
import { Skeleton } from 'primereact/skeleton';
import { useFormik } from 'formik';

const CustomerLsiting = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');

  const [employeeList, setEmployeeList] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState<_Object>({})
  const [visible, setVisible] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const toastRef = useRef<any>(null);
  const [filterData, setFilterData] = useState<_Object>({
    page: 1,
    filter: {
      role: "customer",
      // onboarding: type || ""
    },
    per_page: 10,
    q: "",
    sort: '-created_at',
  })
  const navigate = useNavigate();

  const fetchEmployeeList = async () => {
    try {
      setLoading(true);
      const data = await userService.getUsers(filterData);
      setEmployeeList(data.items);
      setPagination(data.pagination);
    } catch (error) {
      console.error('Error fetching employees:', error);
    } finally {
      setLoading(false);
    }
  };

  const deleteItem = async (itemToDelete: null) => {
    if (!itemToDelete) return;
    try {
      setLoading(true);
      const response = await userService.deleteUsers(itemToDelete);
      if (!response.error) {
        showTostify(toastRef, 'success', response.message);
        await fetchEmployeeList();
        setVisible(false); // Close the modal here
        setItemToDelete(null); // Reset itemToDelete after deletion
      }
    } catch (error: any) {
      showTostify(toastRef, 'error', error.message);
      console.error('Error deleting employee:', error);
    } finally {
      setLoading(false);
    }
  };

  const onPageChange = (event: any) => {
    const currentPage = Math.floor(event.first / event.rows) + 1;

    setFilterData((prev) => ({
      ...prev,
      page: currentPage,
      per_page: event.rows,
    }));
  };

  useEffect(() => {
    if (filterData.filter?.onboarding) { fetchEmployeeList(); }
  }, [filterData]);

  useEffect(() => {
    if (type) {
      setFilterData((prev) => ({
        ...prev,
        q: '',
        page: 1,
        filter: {
          onboarding: type
        }
      }));
    }
  }, [type]);

  const formikFilter = useFormik({
    initialValues: filterData,
    enableReinitialize: true,
    onSubmit: (values: _Object) => {
      setFilterData((prev) => ({
        ...prev,
        q: values.q.trim(),
        page: 1
      }));
    }
  });

  return (
    <div className="CustomerLsiting">
      <SEOHeader title="Customers" />
      <CustomToast ref={toastRef} />
      <div className="flex justify-content-between align-items-center">
        <div className="p-inputgroup search-bar col-6">
          <form onSubmit={formikFilter.handleSubmit}>
            <div className='form-group mb-0 mr-2'>
              <Button type='submit' className='search-loading bg-transparent p-0 border-none'
                disabled={loading}>
                {loading && <i className="pi pi-spin pi-spinner"
                  style={{ fontSize: '1rem' }}
                >
                </i>}
              </Button>

              <IconField iconPosition="left">
                <InputIcon className="pi pi-search"> </InputIcon>
                <InputText placeholder="Search"
                  name='q'
                  onChange={formikFilter.handleChange}
                  onBlur={formikFilter.handleBlur}
                  value={formikFilter.values.q} />
              </IconField>

              {filterData.q && <Button type='button'
                onClick={() => {
                  setFilterData((prev) => ({
                    ...prev,
                    q: '',
                    page: 1
                  }))
                }}
                severity="secondary" text className='bg-transparent p-0 border-none absolute top-0 right-0 mr-3'>
                <span className="pi pi-times "> </span>
              </Button>}
            </div>
          </form>

          {pagination?.total_items > 0 &&
            <div className='total-items flex align-items-center text-sm'>
              Total items: {pagination.total_items || ""}
            </div>
          }
        </div>

        <div className="col-4 text-right">
          <Button label="Add New Customer" icon="pi pi-plus" className="primary" onClick={() => navigate(`${routes.customers}/create?type=${type}`)} />
        </div>
      </div>

      <div className="col">
        <div className="card">
          <table className='w-full'>
            <thead>
              <tr>
                <th>#</th>
                <th>Full Name</th>
                <th>ID</th>
                <th>ID Number</th>
                <th>Phone Number</th>
                <th>Email</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {loading && Array.from({ length: 5 }).map((_, index) => (
                <tr key={index}>
                  <td><Skeleton height="2rem" borderRadius="1px" /></td>
                  <td><Skeleton height="2rem" borderRadius="1px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  <td><Skeleton height="2rem" borderRadius="4px" /></td>
                </tr>
              ))}
              {!loading && employeeList?.map((item: _Object, i: number) => (
                <tr>
                  <td>{((filterData.page - 1) * filterData.per_page) + (i + 1)}</td>
                  <td>{item?.full_name || "-"}</td>
                  <td>{item?.username || "-"}</td>
                  <td>{item?.id_number || '-'}</td>
                  <td>{item?.phone_number1 || '-'}</td>
                  <td>{item?.email || '-'}</td>
                  <td>{getStatusLabel(item?.status) || '-'}</td>
                  <td>
                    <div>
                      <Button
                        icon="pi pi-pencil"
                        rounded
                        text
                        className="h-auto w-auto bg-transparent p-0 border-noround inline"
                        onClick={() => navigate(`${routes.customers}/edit/${item.id}?type=${type}`)}
                        style={{ color: '#959CB6' }}
                      />
                      <Button
                        icon="pi pi-trash"
                        onClick={() => {
                          setVisible(true);
                          setItemToDelete(item.id);
                        }}
                        rounded
                        text
                        className="h-auto w-auto bg-transparent p-0 border-noround inline"
                        style={{ color: 'var(--torch-red)' }}
                      />
                    </div>
                  </td>
                </tr>
              ))}
              {!loading && employeeList?.length === 0 && <tr>
                <td colSpan={11}>No available options</td>
              </tr>
              }
            </tbody>
          </table>
        </div>

        {!loading && pagination?.total_pages > 1 &&
          <Paginator
            first={(filterData.page - 1) * filterData.per_page}
            rows={filterData.per_page}
            totalRecords={pagination.total_items}
            rowsPerPageOptions={[10, 20, 30]}
            onPageChange={onPageChange}
          />
        }
      </div>
      <DeleteItem
        title="Employee"
        visible={visible}
        onHide={() => setVisible(false)}
        deleteItem={() => deleteItem(itemToDelete)}
      />
    </div>
  );
};

export default CustomerLsiting;
